import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface DisconnectShopifyRequest {
  companyId: string;
}

const disconnectShopify = async (companyId: string): Promise<void> => {
  const fn = httpsCallable<DisconnectShopifyRequest, any>(functions, 'shopify_disconnect');
  await fn({ companyId });
};

export { disconnectShopify };
